export default __webpack_public_path__ + "static/media/google-play-w.c196655d.png";